import {
  caseDetail,
  casesList,
  removeIntegration,
  cancelCase,
  deleteCase,
  deleteBusinessProfile,
  snapshot,
  OPEN_DELETE_BUSINESS_PROFILE_MODAL,
  CLOSE_DELETE_BUSINESS_PROFILE_MODAL,
  OPEN_CANCEL_CASE_MODAL,
  CLOSE_CANCEL_CASE_MODAL,
} from './types';
import { createActionCreator } from '../utils/helpers';

export const removeCaseIntegration = createActionCreator(removeIntegration.request, 'id');
export const requestCase = createActionCreator(caseDetail.request, 'id');
export const requestCaseSuccess = createActionCreator(caseDetail.success, 'response');
export const requestCaseFailure = createActionCreator(caseDetail.failure, 'error');
export const requestCasesList = createActionCreator(casesList.request);
export const requestCasesListSuccess = createActionCreator(casesList.success, 'response');
export const requestCasesListFailure = createActionCreator(casesList.failure, 'error');

export const requestCancelCase = (caseId, promise) => ({
  type: cancelCase.request,
  caseId,
  promise,
});

export const requestCancelCaseSuccess = (caseId, response) => ({
  type: cancelCase.success,
  caseId,
  response,
});

export const requestCancelCaseFailure = (error) => ({
  type: cancelCase.failure,
  error,
});

export const requestDeleteCaseSuccess = (caseId, response) => ({
  type: deleteCase.success,
  caseId,
  response,
});

export const requestDeleteCaseFailure = (error) => ({
  type: deleteCase.failure,
  error,
});

export const requestDeleteBusinessProfile = (businessId, promise) => ({
  type: deleteBusinessProfile.request,
  businessId,
  promise,
});

export const requestDeleteBusinessProfileSuccess = (businessId, response) => ({
  type: deleteBusinessProfile.success,
  businessId,
  response,
});

export const requestDeleteBusinessProfileFailure = (error) => ({
  type: deleteBusinessProfile.failure,
  error,
});

export const openDeleteBusinessProfileModal = (caseInstance) => ({
  type: OPEN_DELETE_BUSINESS_PROFILE_MODAL,
  case: caseInstance,
});

export const closeDeleteBusinessProfileModal = () => ({
  type: CLOSE_DELETE_BUSINESS_PROFILE_MODAL,
});

export const openCancelCaseModal = (caseInstance) => ({
  type: OPEN_CANCEL_CASE_MODAL,
  case: caseInstance,
});

export const closeCancelCaseModal = () => ({
  type: CLOSE_CANCEL_CASE_MODAL,
});

export function requestSnapshot(entityId) {
  return {
    type: snapshot.request,
    entityId,
  };
}

export function requestSnapshotSuccess(entityId, name, generatedAt) {
  return {
    type: snapshot.success,
    entityId,
    name,
    generatedAt,
  };
}

export function requestSnapshotFailure(entityId, error) {
  return {
    type: snapshot.failure,
    entityId,
    error,
  };
}
